import JSZip from 'jszip';
import {extractExternalLinksFromString} from '../stringUtils/extractExternalLinksFromString';

export interface ExternalLink {
  filePath: string;
  links: string[];
}

/**
 * This code snippet extracts external links, not from clinch domain, from a zip file, and creates an array of objects
 * containing the file path and the external links. These are processed by the BE and replaced with clinch urls.
 * */
export async function extractExternalLinksFromZip(zipFile: File): Promise<ExternalLink[]> {
  const zip = await JSZip.loadAsync(zipFile);
  const externalLinks: ExternalLink[] = [];

  async function processZipEntries(path: string, folder: JSZip) {
    for (const [relativePath, file] of Object.entries(folder.files)) {
      if (
        relativePath.endsWith('.html') ||
        relativePath.endsWith('.css') ||
        relativePath.endsWith('.js')
      ) {
        const content = await file.async('string');
        const links = extractExternalLinksFromString(content);

        if (links.length > 0) {
          externalLinks.push({filePath: `${path}${relativePath}`, links});
        }
      }
    }
  }

  await processZipEntries('', zip);

  return externalLinks;
}

export async function extractExternalLinksFromMultipleZips(
  zipFiles: File[],
): Promise<ExternalLink[]> {
  const allExternalLinks: ExternalLink[] = [];

  for (const zipFile of zipFiles) {
    const externalLinksFromSingleZip = await extractExternalLinksFromZip(zipFile);
    allExternalLinks.push(...externalLinksFromSingleZip);
  }

  return allExternalLinks;
}
